module.exports = __webpack_public_path__ + "img/tom-straphel-sensei.16c9ee49.jpg";